import { Box, Button, Collapse } from '@mui/material'
import { Sliders } from '@phosphor-icons/react'
import i18n from 'lang/idiomas'
import { useState } from 'react'
import DocumentTypeFilter from './filters/DocumentTypeFilter.jsx'
/**
 * The EfacturasFilters component
 * @component
 *
 * @param {Object} props
 * @param {boolean} props.loader
 * @param {function} props.handleChangeFilters
 * @returns {JSX.Element}
 */

const EfacturasFilters = ({ loader, handleDocumentType }) => {
  const [expanded, setExpanded] = useState(false)

  const [documentType, setDocumentType] = useState('')

  return (
    <Box
      sx={{
        width: '100%',
        mb: 2,
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <Box sx={{ display: 'flex', gap: '8px', ml: 'auto' }}>
          <Button
            sx={{
              color: 'action.active',
              display: 'flex',
            }}
            endIcon={<Sliders size={30} weight={expanded ? 'fill' : 'light'} />}
            onClick={() => setExpanded(!expanded)}
          >
            {i18n.t('general.filtros', { defaultValue: 'Filtros' })}
          </Button>
        </Box>
      </Box>
      <Collapse in={expanded}>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            display: 'flex',
            gap: '5px',
            flexDirection: 'column',
          }}
        >
          <DocumentTypeFilter
            documentType={documentType}
            handleChangeDocumentType={setDocumentType}
          />
          <Button
            disabled={loader}
            variant="contained"
            disableElevation
            sx={{
              ml: 'auto',
              my: 2,
              mb: 4,
              display: 'block',
              width: '100%',
              '&:disabled': {
                backgroundColor: 'lightgrey',
              },
            }}
            onClick={(e) => {
              handleDocumentType(documentType)
            }}
          >
            {i18n.t('general.consulta', { defaultValue: 'Consultar' })}
          </Button>
        </Box>
      </Collapse>
      <Box></Box>
    </Box>
  )
}

export default EfacturasFilters
